<template>
  <div v-show="loading" class="loader__wrapper">
    <div class="loader">
      <span class="sr_only" aria-live="polite" aria-busy="true">
        {{ i18n.$gettext('Loading') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingMessages',
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  }
}
</script>
